// /pdf/sections/infrastructure.js
import { addMetricRow } from "../helpers";

export function renderInfrastructure(doc, data, icons, lastY) {
    let y = lastY;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("2. Infrastructure", 14, y);
    y += 15;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Tools used by Conservancy Department", 14, y);
    y += 10;

    const toolsProfile = data["Tools used by Conservancy Department"] || [];

    let Dustbin = toolsProfile.find(i => i.indicator === "Dustbin")?.value || "";
    let VacuumTanker = toolsProfile.find(i => i.indicator === "Vacuum Tanker")?.value || "";
    let STS = toolsProfile.find(i => i.indicator === "STS")?.value || "";


    const toolsMetrics = [
        { icon: icons.toolsDustbin, label: "Dustbin", value: Dustbin },
        { icon: icons.toolsTanker, label: "Vacuum Tanker", value: VacuumTanker },
        { icon: icons.toolsSts, label: "STS", value: STS },
    ];
    addMetricRow(doc, toolsMetrics, y);
    y += 30;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Vehicles used in SWM", 14, y);
    y += 10;

    const toolsVehicles = data["Vehicles used in SWM"] || [];

    let Compactor = toolsVehicles.find(i => i.indicator === "Compactor")?.value || "";
    let DumpTruck = toolsVehicles.find(i => i.indicator === "Dump Truck")?.value || "";
    let Others = toolsVehicles.find(i => i.indicator === "Others")?.value || "";
    let Trolley = toolsVehicles.find(i => i.indicator === "Trolley")?.value || "";


    const toolsVehiclesMetrics = [
        { icon: icons.toolsCompactor, label: "Compactor", value: Compactor },
        { icon: icons.toolsDumpTruck, label: "Dump Truck", value: DumpTruck },
        { icon: icons.toolsOthers, label: "Others", value: Others },
        { icon: icons.toolsTrolley, label: "Trolley", value: Trolley },
    ];
    addMetricRow(doc, toolsVehiclesMetrics, y);
    y += 30;




    return y;
}
